// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalWp {
  position: fixed;
  z-index: 30;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  overflow-y: hidden;
  list-style: none;
  }
  .modalWp button {
    outline: none;
    cursor: pointer;
    border: 0;
  }
  .modalWp > section {
    width: 90%;
    max-width: 600px;
    margin: 0 auto;
    border-radius: 0.3rem;
    background-color: #fff;
    overflow: hidden;
    box-shadow: 1px 1px 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    transition: all 0.3s cubic-bezier(.25,.8,.25,1);
  }
  .modalWp > section > header {
    position: relative;
    padding: 16px 64px 16px 16px;
    background-color: #f1f1f1;
    font-weight: 700;
  }
  .modalWp > section > header button {
    position: absolute;
    top: 15px;
    right: 15px;
    width: 30px;
    font-size: 21px;
    font-weight: 700;
    text-align: center;
    color: #999;
    background-color: transparent;
  }
  .modalWp > section > main {
    padding: 16px;
    border-bottom: 1px solid #dee2e6;
    border-top: 1px solid #dee2e6;
    height: 500px;
  }
  .modalWp > section > footer {
    padding: 12px 16px;
    text-align: right;
  }
  .modalWp > section > footer button {
    padding: 6px 12px;
    color: #fff;
    background-color: #6c757d;
    border-radius: 5px;
    font-size: 13px;
    margin-right: 10px;
  }
  .modalWp.openModal {
    display: flex;
    align-items: center;
  }
`, "",{"version":3,"sources":["webpack://./src/layouts/wpDetail/components/modalCss.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,OAAO;EACP,MAAM;EACN,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB;EACA;IACE,aAAa;IACb,eAAe;IACf,SAAS;EACX;EACA;IACE,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,sBAAsB;IACtB,gBAAgB;IAChB,wEAAwE;IACxE,+CAA+C;EACjD;EACA;IACE,kBAAkB;IAClB,4BAA4B;IAC5B,yBAAyB;IACzB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,6BAA6B;EAC/B;EACA;IACE,aAAa;IACb,gCAAgC;IAChC,6BAA6B;IAC7B,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB","sourcesContent":[".modalWp {\n  position: fixed;\n  z-index: 30;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  overflow-y: hidden;\n  list-style: none;\n  }\n  .modalWp button {\n    outline: none;\n    cursor: pointer;\n    border: 0;\n  }\n  .modalWp > section {\n    width: 90%;\n    max-width: 600px;\n    margin: 0 auto;\n    border-radius: 0.3rem;\n    background-color: #fff;\n    overflow: hidden;\n    box-shadow: 1px 1px 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);\n    transition: all 0.3s cubic-bezier(.25,.8,.25,1);\n  }\n  .modalWp > section > header {\n    position: relative;\n    padding: 16px 64px 16px 16px;\n    background-color: #f1f1f1;\n    font-weight: 700;\n  }\n  .modalWp > section > header button {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    width: 30px;\n    font-size: 21px;\n    font-weight: 700;\n    text-align: center;\n    color: #999;\n    background-color: transparent;\n  }\n  .modalWp > section > main {\n    padding: 16px;\n    border-bottom: 1px solid #dee2e6;\n    border-top: 1px solid #dee2e6;\n    height: 500px;\n  }\n  .modalWp > section > footer {\n    padding: 12px 16px;\n    text-align: right;\n  }\n  .modalWp > section > footer button {\n    padding: 6px 12px;\n    color: #fff;\n    background-color: #6c757d;\n    border-radius: 5px;\n    font-size: 13px;\n    margin-right: 10px;\n  }\n  .modalWp.openModal {\n    display: flex;\n    align-items: center;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
